import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { ShippingCost } from '../../models/shippment/shipping-cost.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class ShippingCostService {
  private service = "api/ShippingCost"; //Controller Name
  private helperService = "api/Country";

  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService) { }

  AddShippingCost(shippingCost: ShippingCost) {
    return this.http
      .post(`${this.service}`, shippingCost, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetShippingCosts() {
    return this.http.get(`${this.service}/GetShippingCosts`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetCityList() {
    return this.http.get(`${this.helperService}/GetCityList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  GetShippingCostById(id: string) {
    return this.http.get(`${this.service}/GetShippingCost?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  DeleteShippingCost(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shippment/shipping-cost.service.ts